import { createReducer } from '@reduxjs/toolkit';
import { clearState } from '../Actions/index';
import {
  fetchFileTypes,
  fetchIndustries,
  fetchPageTypes,
  fetchStates,
  fetchUserLevels,
  fetchSubscriptions,
  fetchCustomOptions,
  fetchExistingEmails,
  fetchManufacturers,
  fetchCategories,
  fetchSubCategories,
  fetchClients,
  fetchClientTypes,
  fetchLocationTypes,
  fetchMarketSegments,
  fetchMarketSubSegments,
  fetchUsers,
  fetchInventoryTypes,
  fetchVendors,
  fetchClientsWithLocationList,
  fetchFrequencies,
  fetchAssetStatuses,
  fetchAssetTypes,
  fetchEquipmentTypes,
  fetchCountries,
} from '../Actions/CommonFields';
import { CommonFieldsReference } from '../Models/CommonFieldsReference';

const initialState: CommonFieldsReference = {
  states: [],
  countries: [],
  userLevels: [],
  industries: [],
  fileTypes: [],
  pageTypes: [],
  subscriptions: [],
  customOptions: [],
  existingEmails: [],
  manufacturers: [],
  categories: [],
  subCategories: [],
  clients: [],
  clientTypes: [],
  marketSegments: [],
  marketSubSegments: [],
  locationTypes: [],
  users: [],
  inventoryTypes: [],
  equipmentTypes: [],
  vendors: [],
  clientsWithLocation: [],
  frequencies: [],
  assetStatuses: [],
  assetTypes: [],
};

const CommonFieldsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(fetchStates.fulfilled, (state, action) => {
      return { ...state, states: action.payload };
    })
    .addCase(fetchCountries.fulfilled, (state, action) => {
      return { ...state, countries: action.payload };
    })
    .addCase(fetchUserLevels.fulfilled, (state, action) => {
      return { ...state, userLevels: action.payload };
    })
    .addCase(fetchPageTypes.fulfilled, (state, action) => {
      return { ...state, pageTypes: action.payload };
    })
    .addCase(fetchIndustries.fulfilled, (state, action) => {
      return { ...state, industries: action.payload };
    })
    .addCase(fetchFileTypes.fulfilled, (state, action) => {
      return { ...state, fileTypes: action.payload };
    })
    .addCase(fetchSubscriptions.fulfilled, (state, action) => {
      return { ...state, subscriptions: action.payload };
    })
    .addCase(fetchCustomOptions.fulfilled, (state, action) => {
      return { ...state, customOptions: action.payload };
    })
    .addCase(fetchExistingEmails.fulfilled, (state, action) => {
      return { ...state, existingEmails: action.payload };
    })
    .addCase(fetchManufacturers.fulfilled, (state, action) => {
      return { ...state, manufacturers: action.payload };
    })
    .addCase(fetchCategories.fulfilled, (state, action) => {
      return { ...state, categories: action.payload };
    })
    .addCase(fetchSubCategories.fulfilled, (state, action) => {
      return { ...state, subCategories: action.payload };
    })
    .addCase(fetchClients.fulfilled, (state, action) => {
      return { ...state, clients: action.payload };
    })
    .addCase(fetchClientTypes.fulfilled, (state, action) => {
      return { ...state, clientTypes: action.payload };
    })
    .addCase(fetchMarketSegments.fulfilled, (state, action) => {
      return { ...state, marketSegments: action.payload };
    })
    .addCase(fetchMarketSubSegments.fulfilled, (state, action) => {
      return { ...state, marketSubSegments: action.payload };
    })
    .addCase(fetchLocationTypes.fulfilled, (state, action) => {
      return { ...state, locationTypes: action.payload };
    })
    .addCase(fetchUsers.fulfilled, (state, action) => {
      return { ...state, users: action.payload };
    })
    .addCase(fetchInventoryTypes.fulfilled, (state, action) => {
      return { ...state, inventoryTypes: action.payload };
    })
    .addCase(fetchEquipmentTypes.fulfilled, (state, action) => {
      return { ...state, equipmentTypes: action.payload };
    })
    .addCase(fetchVendors.fulfilled, (state, action) => {
      return { ...state, vendors: action.payload };
    })
    .addCase(fetchClientsWithLocationList.fulfilled, (state, action) => {
      return { ...state, clientsWithLocation: action.payload };
    })
    .addCase(fetchFrequencies.fulfilled, (state, action) => {
      return { ...state, frequencies: action.payload };
    })
    .addCase(fetchAssetStatuses.fulfilled, (state, action) => {
      return { ...state, assetStatuses: action.payload };
    })
    .addCase(fetchAssetTypes.fulfilled, (state, action) => {
      return { ...state, assetTypes: action.payload };
    })
    .addCase(clearState, (state, action) => {
      return initialState;
    });
});

export default CommonFieldsReducer;
